<template>
 <div>
   <Tooltip :content="$t(tip)" placement="top">
      <slot>

      </slot>
  </Tooltip>
</div>
</template>

<script>
export default {
  name: 'ipsosTip',
  props: ['tip'],
  data () {
    return {

    }
  },
  components: {

  },
  watch: {
  },
  computed: {

  },
  methods: {

  },
  created () {

  },
  mounted () {

  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/plugin/element/DubuTip.vue